import React from "react";
import { useLocation, useNavigate } from "react-router-dom";
import "./BottomNavigation.scss";

const BottomNavigation: React.FC = () => {
  const location = useLocation();
  const navigate = useNavigate();

  return (
    <div className="mobile-nav shadow-lg d-flex justify-content-around align-items-center">
      <div
        className={`nav-item nav-ps-item ${location.pathname === "/contracts" ? "active" : ""}`}
        onClick={() => navigate("/contracts")}
      >
        <i className="fa fa-file-contract" style={{ fontSize: 24 }}></i>
        <div className="nav-label">Contract</div>
      </div>

      <div
        className={`nav-item nav-ps-item ${location.pathname === "/manage-store" ? "active" : ""}`}
        onClick={() => navigate("/manage-store")}
      >
        <i className="fa fa-store" style={{ fontSize: 24 }}></i>
        <div className="nav-label">Kelola Toko</div>
      </div>

      <div
        className={`nav-item nav-ps-item ${location.pathname === "/profile" ? "active" : ""}`}
        onClick={() => navigate("/profile")}
      >
        <i className="fa fa-user" style={{ fontSize: 24 }}></i>
        <div className="nav-label">Profile</div>
      </div>
    </div>
  );
};

export default BottomNavigation;